<template>
    <div>
        <form
            id="CreacionEdicionFichasSgi"
            @submit.prevent="EnvivarFormulario()"
            @keydown.enter.prevent
        >
            <div v-for="(form, etapa) in forms" :key="etapa">
                <div>
                    <forms-vue-crear
                        v-bind:title="form.config.title"
                        v-bind:form="form.form"
                        @cambios="cambios"
                        v-bind:submit_url="form.config.submit_url"
                        v-bind:redirect_submit_url="
                            form.config.redirect_submit_url
                        "
                        v-bind:watch="form.config.watch"
                        v-bind:submit_in_url="form.config.submit_in_url"
                        :etapa="etapa"
                        :class="form.config.actual ? 'etapa_actual' : ''"
                    ></forms-vue-crear>
                </div>
                <div v-if="form.etapa && form.etapa.multi_etapa === 1">
                    <div
                        class="content"
                        v-if="!form.etapa.multi_etapa_registros_datos_valores"
                    >
                        <div class="container container-height">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="card">
                                        <div class="card-header">
                                            <h3 class="card-title">
                                                {{ form.form[0][0].title }} -
                                                Etapa Multi Tareas
                                            </h3>
                                            <div class="card-tools">
                                                <button
                                                    type="button"
                                                    class="btn btn-tool btn-success btn-small"
                                                    @click="
                                                        form.etapa
                                                            .multi_etapa_registros++
                                                    "
                                                >
                                                    <i class="fas fa-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="form.etapa.multi_etapa_registros_datos_valores">
                        <div
                            v-for="(multi_etapa, keyMulti) in form.etapa
                                .multi_etapa_registros_datos_valores"
                            :key="keyMulti"
                        >
                            <forms-vue-crear
                                :multi_etapa="true"
                                :titulo_previo="true"
                                :multi_etapa_lugar="keyMulti"
                                v-bind:title="form.config.title"
                                v-bind:form="multi_etapa"
                                @cambios="cambios"
                                v-bind:submit_url="form.config.submit_url"
                                v-bind:redirect_submit_url="
                                    form.config.redirect_submit_url
                                "
                                v-bind:watch="form.config.watch"
                                v-bind:submit_in_url="form.config.submit_in_url"
                                :etapa="etapa"
                                :class="
                                    form.config.actual ? 'etapa_actual' : ''
                                "
                            ></forms-vue-crear>
                        </div>
                    </div>
                    <div v-else>
                        <div
                            v-for="multi_etapa in form.etapa
                                .multi_etapa_registros"
                            :key="multi_etapa"
                        >
                               <pre>{{ form }}</pre>
                               <pre>{{ multi_etapa }}</pre>
                               <pre>{{ etapa }}</pre>

                            <forms-vue-crear
                                :multi_etapa="true"
                                :multi_etapa_lugar="multi_etapa"
                                v-bind:title="form.config.title"
                                v-bind:form="form.multiForm"
                                @cambios="cambios"
                                v-bind:submit_url="form.config.submit_url"
                                v-bind:redirect_submit_url="
                                    form.config.redirect_submit_url
                                "
                                v-bind:watch="form.config.watch"
                                v-bind:submit_in_url="form.config.submit_in_url"
                                :etapa="etapa"
                                :class="
                                    form.config.actual ? 'etapa_actual' : ''
                                "
                            ></forms-vue-crear>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">Archivos Adjuntos</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-sm-12">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Tipo de Archivo</th>
                                            <th>Archivo</th>
                                            <th>Fecha Carga</th>
                                            <th>Usuario</th>
                                            <th>Descargar</th>
                                            <th v-if="ficha.estado === 'A'">
                                                Eliminar
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(archivo, akey) in archivos"
                                            :key="akey"
                                        >
                                            <td>
                                                {{ archivo.nro_archivo }}
                                            </td>
                                            <td>
                                                {{
                                                    archivo.tipo_archivo_descripcion
                                                }}
                                            </td>
                                            <td>
                                                {{ archivo.nombre_archivo }}
                                            </td>
                                            <td>
                                                {{ archivo.fecha }}
                                            </td>
                                            <td>
                                                {{ archivo.apellido }}
                                                {{ archivo.nombre }}
                                            </td>
                                            <td style="text-align: center">
                                                <a
                                                    :href="
                                                        './../descargar-adjunto/' +
                                                        archivo.nro_archivo
                                                    "
                                                    target="_blank"
                                                >
                                                    <button
                                                        type="button"
                                                        class="btn btn-sm btn-success pull-right"
                                                    >
                                                        <i
                                                            class="fa fa-download"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </button>
                                                </a>
                                            </td>
                                            <td
                                                style="text-align: center"
                                                v-if="ficha.estado === 'A'"
                                            >
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-danger pull-right"
                                                    @click="
                                                        EliminarAdjunto(
                                                            archivo.nro_archivo
                                                        )
                                                    "
                                                >
                                                    <i
                                                        class="fa fa-close"
                                                        aria-hidden="true"
                                                    ></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="col-sm-12 subir_archivo"
                    v-if="$route.query.subirArchivo === 'S'"
                >
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">Adjuntar Archivo</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="tipo_archivo">
                                        Tipo de Archivo
                                    </label>
                                    <select
                                        name="tipo_archivo"
                                        id="tipo_archivo"
                                        class="form-control"
                                    >
                                        <option value="" selected>
                                            Selecionar
                                        </option>
                                        <option value="P">Principal</option>
                                        <option value="S">Segundario</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="archivo"> Archivo </label>
                                    <input
                                        id="archivo"
                                        name="archivo"
                                        class="form-control"
                                        type="file"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-md-6">
                                    <button
                                        type="button"
                                        class="btn btn-warning pull-left"
                                        @click="irPaginaAnterior"
                                    >
                                        Volver
                                    </button>
                                </div>
                                <div class="col-md-6">
                                    <button
                                        @click="EnviarFormularioAdjunto()"
                                        type="button"
                                        class="btn btn-success pull-right"
                                    >
                                        Adjuntar Archivos
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12" v-if="$route.query.subirArchivo !== 'S'">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-md-12">
                                    <button
                                        v-if="
                                            $route.params.id &&
                                            ficha.estado &&
                                            ficha.estado != 'B'
                                        "
                                        type="button"
                                        @click="EliminarFicha()"
                                        class="btn-margin btn btn-danger pull-center"
                                    >
                                        Eliminar
                                    </button>
                                    <button
                                        v-else-if="
                                            ficha.estado && ficha.estado == 'B'
                                        "
                                        type="button"
                                        @click="RecuperarFicha()"
                                        class="btn-margin btn btn-success pull-right"
                                    >
                                        Recuperar Ficha
                                    </button>
                                    <button
                                        v-if="$route.query.volverEtapa"
                                        type="button"
                                        @click="VolverEtapa()"
                                        class="btn-margin btn btn-success pull-right"
                                    >
                                        Volver Etapa
                                    </button>
                                    <button
                                        v-else-if="
                                            (!ficha.estado ||
                                                ficha.estado == 'A') &&
                                            !$route.query.subirArchivo
                                        "
                                        type="submit"
                                        class="btn-margin btn btn-success pull-right"
                                    >
                                        Guardar
                                    </button>
                                    <button
                                        v-if="reiniciarCiclo"
                                        type="button"
                                        class="btn-margin btn btn-success pull-right"
                                        @click="abrirModal()"
                                    >
                                        Reiniciar Ciclo
                                    </button>

                                    <button
                                        v-if="this.$route.params.id"
                                        type="button"
                                        @click="ImprimirFicha()"
                                        class="btn-margin btn btn-warning pull-right"
                                    >
                                        Imprimir
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>


        <div
            class="modal fade show"
            tabindex="-1"
            role="dialog"
            style="display: block"
            v-if="mostrarModal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <!-- Encabezado del modal -->
                    <div class="modal-header">
                        <h5 class="modal-title">Reiniciar Ciclo</h5>
                        <button
                            type="button"
                            class="close"
                            @click="cerrarModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <!-- Cuerpo del modal -->
                    <div class="modal-body">
                        <form @submit.prevent="reiniciarCicloSubmit">
                            <div class="form-group">
                                <label for="nombre">Nombre</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="nombre"
                                    v-model="nombre"
                                    placeholder="Ingrese el nombre"
                                    required
                                />
                            </div>
                            <div class="form-group">
                                <label for="descripcion">Descripción</label>
                                <textarea
                                    class="form-control"
                                    id="descripcion"
                                    v-model="descripcion"
                                    rows="3"
                                    placeholder="Ingrese la descripción"
                                    required
                                ></textarea>
                            </div>
                        </form>
                    </div>
                    <!-- Pie del modal -->
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            @click="cerrarModal"
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="reiniciarCicloSubmit"
                        >
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal-backdrop fade show" v-if="mostrarModal"></div>
    </div>
</template>
<script type="text/javascript">
export default {
    methods: {
        abrirModal() {
            this.mostrarModal = true;
        },
        cerrarModal() {
            this.mostrarModal = false;
            this.nombre = "";
            this.descripcion = "";
        },
        reiniciarCicloSubmit() {
            if (!this.nombre.trim() || !this.descripcion.trim()) {
                alert("Por favor, complete todos los campos.");
                return;
            }

            axios
                .post("./../reiniciar-ciclo", {
                    nombre: this.nombre,
                    descripcion: this.descripcion,
                    id: this.$route.params.id,
                })
                .then((response) => {
                    const nuevoId = response.data.id;
                    this.$router.push({
                        name: this.$route.name,
                        params: { id: nuevoId },
                    });
                })
                .catch((error) => {
                    alert(error.response.data.message);
                })
                .finally(() => {
                    this.cerrarModal();
                });
        },

        EnviarFormularioAdjunto() {
            const formData = new FormData();
            const archivo = document.querySelector("#archivo").files[0];
            formData.append("archivo", archivo);
            formData.append("ficha", this.$route.params.id);
            const tipoArchivo = document.querySelector("#tipo_archivo").value;
            formData.append("tipo_archivo", tipoArchivo);

            axios
                .post("./../adjuntar-archivo", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.VerAdjunto();
                    document.querySelector("#archivo").value = "";
                    document.querySelector("#tipo_archivo").value = "";
                    alert(response.data.message);
                })
                .catch((error) => {
                    alert(error.response.data.message);
                });
        },
        VerAdjunto() {
            axios
                .post("./../archivos-adjuntos/" + this.$route.params.id)
                .then((response) => {
                    this.archivos = response.data;
                })
                .catch((error) => {});
        },

        irPaginaAnterior() {
            this.$router.push({
                name: "PendientesFicha",
                params: {
                    lugar: this.$route.params.lugar,
                },
            });
        },

        ImprimirFicha() {
            const url = this.$root.UrlBase("fichas/imprimir/" + this.ficha.id);
            window.open(url, "_blank");
        },

        EliminarFicha() {
            if (
                window.confirm(
                    "¿Estás seguro de que deseas eliminar esta ficha?"
                )
            ) {
                axios
                    .post("./" + this.$route.params.id + "/eliminar")
                    .then((response) => {
                        alert(response.data.message);
                        this.irPaginaAnterior();
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                    });
            } else {
                console.log("Eliminación cancelada");
            }
        },
        RecuperarFicha() {
            if (
                window.confirm(
                    "¿Estás seguro de que deseas recuperar esta ficha?"
                )
            ) {
                axios
                    .post("./" + this.$route.params.id + "/recuperar")
                    .then((response) => {
                        alert(response.data.message);
                        this.irPaginaAnterior();
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                    });
            } else {
                console.log("Eliminación cancelada");
            }
        },
        VolverEtapa() {
            if (
                window.confirm(
                    "¿Estás seguro de que deseas volver a la etapa anterior?"
                )
            ) {
                axios
                    .post("./" + this.$route.params.id + "/volver-etapa")
                    .then((response) => {
                        this.irPaginaAnterior();
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                    });
            } else {
                console.log("Eliminación cancelada");
            }
        },
        EliminarAdjunto(registro) {
            if (
                window.confirm(
                    "¿Estás seguro de que deseas eliminar este adjunto?"
                )
            ) {
                axios
                    .post("./../eliminar-adjuntos/" + registro)
                    .then((response) => {
                        this.VerAdjunto();
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                    });
            } else {
                console.log("Eliminación cancelada");
            }
        },
        async EnvivarFormulario() {
            let formulario = document.getElementById(
                "CreacionEdicionFichasSgi"
            );

            let form = new FormData(formulario);

            this.$root
                .Consulta(
                    "crear-editar-fichas",
                    form,
                    "post",
                    false,
                    true,
                    ".card-body",
                    "initial"
                )
                .then((response) => {
                    if (response.ficha_id) {
                        if (typeof this.$route.params.id != "undefined") {
                            this.irPaginaAnterior();
                        } else {
                            if (confirm("¿Quieres Adjuntar un Archivo?")) {
                                this.$router.push({
                                    name: "FichasEditar",
                                    params: {
                                        id: response.ficha_id,
                                        lugar: this.$route.params.lugar,
                                    },
                                    query: { subirArchivo: "S" },
                                });
                            } else {
                                this.irPaginaAnterior();
                            }
                        }
                    }
                });
        },
        cambios(array) {
            if (!this.$route.params.id) {
                if (array.etapa == 0 && array.values.tipo_nc != this.tipo_nc) {
                    this.forms.splice(1, 100);

                    this.$root
                        .Consulta(
                            this.$root.UrlBase("fichas/formulario/crear-edita"),
                            {
                                tipo_nc: array.values.tipo_nc,
                                etapa: array.etapa,
                            },
                            "post",
                            false,
                            false,
                            false,
                            "",
                            false
                        )
                        .then((response) => {
                            if (response[0].attr) {
                                this.forms[0].form[0][0].attrs.splice(3, 1);
                                this.forms[0].form[0][0].attrs.push(
                                    response[0].attr
                                );
                                this.edit++;
                            }

                            for (let key in response) {
                                if (key > 0) {
                                    let multiAttr = {};
                                    if (
                                        response[key].etapa &&
                                        response[key].etapa
                                            .multi_etapa_registros_datos
                                    ) {
                                        multiAttr =
                                            response[key].etapa
                                                .multi_etapa_registros_datos
                                                .attr;
                                    }
                                    let multiForm = [
                                        [
                                            {
                                                col: "12",
                                                title: response[key].etapa
                                                    .nombre,
                                                etapa_actual:
                                                    response[key].etapa
                                                        .etapa_actual,
                                                etapa_campo:
                                                    response[key].etapa
                                                        .etapa_campo,
                                                footer: {},
                                                attrs: [multiAttr],
                                            },
                                        ],
                                    ];

                                    this.forms.push({
                                        config: {},
                                        form: [
                                            [
                                                {
                                                    col: "12",
                                                    title: response[key].etapa
                                                        .nombre,
                                                    etapa_actual:
                                                        response[key].etapa
                                                            .etapa_actual,
                                                    etapa_campo:
                                                        response[key].etapa
                                                            .etapa_campo,
                                                    footer: {},
                                                    attrs: [response[key].attr],
                                                },
                                            ],
                                        ],
                                        etapa: response[key].etapa,
                                        multiForm: multiForm,
                                    });
                                    this.edit++;
                                }
                            }
                        });
                }
            }
        },
        BuscarFicha() {
            this.forms = [];
            this.$root
                .Consulta("", {}, "post", false, false, ".card-body", "initial")
                .then((resp) => {
                    const response = resp.result;
                    this.reiniciarCiclo = resp.reiniciarCiclo;
                    for (let key in response) {
                        if (response[key].ficha) {
                            this.ficha = response[key].ficha;
                        }
                        let multiAttr = {};
                        if (
                            response[key].etapa &&
                            response[key].etapa.multi_etapa_registros_datos
                        ) {
                            multiAttr =
                                response[key].etapa.multi_etapa_registros_datos
                                    .attr;
                        }

                        let multiForm = [
                            [
                                {
                                    col: "12",
                                    title: response[key].etapa.nombre,
                                    etapa_actual:
                                        response[key].etapa.etapa_actual,
                                    etapa_campo:
                                        response[key].etapa.etapa_campo,
                                    footer: {},
                                    attrs: [multiAttr],
                                },
                            ],
                        ];
                        this.forms.push({
                            config: {
                                actual: response[key].etapa.actual,
                            },
                            form: [
                                [
                                    {
                                        col: "12",
                                        title: response[key].etapa.nombre,
                                        etapa_actual:
                                            response[key].etapa.etapa_actual,
                                        etapa_codi:
                                            response[key].etapa.etapa_codi,
                                        ficha: response[key].ficha,
                                        footer: {},
                                        attrs: [response[key].attr],
                                    },
                                ],
                            ],
                            etapa: response[key].etapa,
                            multiForm: multiForm,
                        });
                        this.edit++;
                    }
                });
            this.edit++;
        },
    },
    data() {
        return {
            mostrarModal: false, // Para mostrar/ocultar el modal
            nombre: "", // Campo de nombre
            descripcion: "", // Campo de descripción
            reiniciarCiclo: false,
            multi_etapa_lugar: {},
            archivoAdjunto: null,
            moduloTitulo: null,
            ficha: {},
            edit: 0,
            tipo_nc: null,
            archivos: [],
            forms: [
                {
                    config: {
                        title: "Alta de Registro",
                        edit_get_url: "",
                        submit_in_url: true,
                    },
                    form: [
                        [
                            {
                                col: "12",
                                title: "Datos Generales	",
                                footer: {},
                                attrs: [
                                    [
                                        {
                                            pretty_name: "ID",
                                            name: "id",
                                            type: "number",
                                            extra: [{ readonly: true }],
                                            value: "",
                                            cols: "2",
                                        },
                                        {
                                            pretty_name: "Numero",
                                            name: "numero",
                                            type: "number",
                                            extra: [{ readonly: true }],
                                            value: "",
                                            cols: "6",
                                        },
                                        {
                                            pretty_name: "Fecha",
                                            name: "fecha",
                                            desc: "date",
                                            type: "date",
                                            extra: [{ readonly: true }],
                                            value:
                                                new Date().getFullYear() +
                                                "-" +
                                                String(
                                                    new Date().getMonth() + 1
                                                ).padStart(2, "0") +
                                                "-" +
                                                new Date().getDate(),
                                            cols: "2",
                                        },
                                        {
                                            pretty_name: "Hora",
                                            name: "hora",
                                            desc: "text",
                                            type: "text",
                                            extra: [{ readonly: true }],
                                            value:
                                                String(
                                                    new Date().getHours()
                                                ).padStart(2, "0") +
                                                ":" +
                                                new Date().getMinutes(),
                                            cols: "2",
                                        },
                                    ],
                                    [
                                        {
                                            pretty_name: "Descripción",
                                            name: "descripcion",
                                            desc: "text",
                                            type: "text",
                                            value: "",
                                            cols: "12",
                                        },
                                    ],
                                    [
                                        {
                                            pretty_name: "Tipo de Registro:	",
                                            name: "tipo_nc",
                                            desc: "select",
                                            type: "select",
                                            extra: "",
                                            value: "",
                                            options: [],
                                            cols: "12",
                                        },
                                    ],
                                ],
                                // footer: {
                                //     buttons: [
                                //         {
                                //             type: "button",
                                //             text: "Cancelar",
                                //             class: "btn btn-danger pull-left",
                                //             route: "HomeSections",
                                //         },
                                //     ],
                                // },
                            },
                        ],
                    ],
                },
            ],
        };
    },
    created() {
        const data = {
            selects: {
                // User: {},
                TipoNC: { categoria_nc: "RE" },
            },
        };

        if (this.$route.params.lugar === "AU") {
            this.moduloTitulo = "Auditoria - Alta";
        } else if (this.$route.params.lugar === "NO") {
            this.moduloTitulo = "Informacion Documentada - Alta";
        } else if (
            this.$route.params.lugar === "NC" ||
            this.$route.params.lugar === "RE"
        ) {
            this.moduloTitulo = "No Conformidad - Alta";
        }

        this.forms[0].config.title = this.moduloTitulo;

        if (this.$route.params && this.$route.params.lugar) {
            data.selects.TipoNC.categoria_nc = this.$route.params.lugar;
        }

        if (typeof this.$route.params.id != "undefined") {
            this.BuscarFicha();
            this.VerAdjunto();
        } else {
            this.$root
                .Consulta(
                    this.$root.UrlBase("selects/init"),
                    data,
                    "post",
                    false,
                    false,
                    false,
                    "",
                    false
                )
                .then((response) => {
                    this.forms[0].form[0][0].attrs[2][0].options =
                        response.TipoNC;
                });
        }
    },
    watch: {},
};
</script>
<style>
/* Opcional: estilos adicionales para alinear o personalizar */
.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  justify-content: space-between;
}
</style>
